import React, { ReactNode } from 'react';
import styled from 'styled-components';

/**
 * Orderbook's `scrollIntoView` cause whole mobile page scroll (2x scrolls).
 * Hotfix: Center Orderbook and then scroll this panel to the top.
 */
// export const BUYSELL_MOBILE_SCROLL_CLASS = 'buysellMobileScrollableClass';

export const InputPairPanel = styled.div<{
  $noTopPadding?: boolean;
  $noBottomPadding?: boolean;
}>`
  padding: ${props =>
    `${props.$noTopPadding ? '0' : '2px'} 0 ${
      props.$noBottomPadding ? '0' : '2px'
    }`};
  align-items: center;
`;

export const InputTitle = styled.div`
  margin-right: 5px;
  margin-bottom: 4px;
`;

export const InputWrap = styled.div`
  flex-basis: 100px;
  min-width: 100px;
  flex-grow: 0;
  .isMobileStyle & {
    min-width: 85px;
  }
`;

const TwoColWrap = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
`;

const LabelSpan = styled.span`
  color: #9d98a4;
`;

const DigitSpan = styled.span`
  font-family: var(--digitsFontFamily);
`;

const BuySpan = styled.span`
  font-family: var(--digitsFontFamily);
  color: var(--green4);
`;

const SellSpan = styled.span`
  font-family: var(--digitsFontFamily);
  color: var(--red3);
`;

export const TwoColumnData = ({
  label,
  buySide,
  sellSide,
}: {
  label: string;
  buySide: ReactNode;
  sellSide: ReactNode;
}) => {
  return (
    <TwoColWrap>
      <LabelSpan>{label}</LabelSpan>
      <div>
        <BuySpan>{buySide || '-'}</BuySpan> /{' '}
        <SellSpan>{sellSide || '-'}</SellSpan>
      </div>
    </TwoColWrap>
  );
};

export const TwoColumnDataSimple = ({
  label,
  leftSide,
  rightSide,
}: {
  label: string;
  leftSide?: ReactNode;
  rightSide: ReactNode;
}) => {
  return (
    <TwoColWrap>
      <LabelSpan>{label}</LabelSpan>
      <div>
        {leftSide && (
          <>
            <DigitSpan>{leftSide}</DigitSpan> /{' '}
          </>
        )}
        <DigitSpan>{rightSide}</DigitSpan>
      </div>
    </TwoColWrap>
  );
};
